export const SET_QUOTE_DATA = "SET_QUOTE_DATA";
export const SET_QUOTE_LOADING = "SET_QUOTE_LOADING";
export const DATA_FETCH_INIT = "DATA_FETCH_INIT";
export const SET_COMMON_ERROR_VALIDATOR = "SET_COMMON_ERROR_VALIDATOR";
export const RESET_COMMON_ERROR_VALIDATOR = "RESET_COMMON_ERROR_VALIDATOR";

const initialState = {
  create_quote_popup: false,
  P_quote_name: "",
  P_partner: "",
  P_quote_date: new Date(),
  P_report_type: "",
  P_dealer_id: "",
  P_opportunity_lead: "",
  file_upload_percentage: 0,
  P_file: null,
  P_partner_name: "",
  isQuoteLoading: false,
  quote_list_refetch: false,
  quote_page: 1,
  quote_perpage: 20,
  quote_search: "",
  total_quotes: 0,
  quote_list: [],
  P_quote_info: null,
  purchaseTutorialModal: false,

  verticalsList: [],
  dealer_id: null,
  business_type: null,
  report_types: [],
  disable_quote_add_btn: false,
  P_session_info: null,
  partner_list: [],
  distributer_list: [],
  currency_ratio: null,
  P_distributor: "",
  P_temp_quote: false,
  P_discounted: false,
  C_temp_session: false,

  // quote editz

  Ed_dealer_id: null,
  Ed_quote_date: null,
  Ed_quote_name: "",
  disable_quote_edit_btn: false,
  Ed_report_type: "",
  edit_quote_popup: false,
  Ed_partner: "",
  Ed_distributor: "",
  Ed_temp_session: false,
  Ed_discounted: false,
  Ed_quote_id: "",
  Ed_opportunity_lead: "",

  // delete quotess

  delete_quote_popup: false,
  Del_quote_details: null,
  del_btn_disable: false,

  //summary

  isSummaryResultLoading: true,
  isInvalidSessionLink: false,
  summaryData: {},
  ppePlanIdPurchase: "",
  dealerIdPurchase: "",
  sessionMyplanCheck: true,
  submit_btn_disable: false,
  Preg_plans: [],
  dataSameMulti: "",
  dataMulti: "",

  //csm
  engageCsm: false, //modal switch
  engage_mail_cc: "",
  engage_mail_to: "",
  engage_mail_subject: "",
  engage_mail_html: "",

  //purchase results

  purchaseResults_list: [],
  isResultDataLoading: false,
  purchaseResults_Refetch: false,
  purchaseResults_page: 1,
  purchaseResults_perpage: 20,
  purchaseResults_total_count: 0,

  // kit list

  KitPage: 1,
  KitPerpage: 20,
  KitCount: 0,
  kitPlanId: "",
  KitList: [],
  isKitListOpen: false,
  kiListInfo: {},
  KitRefetch: false,
  KitLoading: false,
  submit_kit_btn_disable: false,

  purchaseCheckKit_perpage: 20,

  // register plan

  show_confirmation_popup: false,
  Creg_partner: "",
  show_manual_plan_popup: false,
  Cdeal_id: "",
  WSdeal_id: "",
  WSact_id_u: "",
  WSact_id_e: "",
  WSact_id_a: "",
  CRparty_id: "",
  purchase_Creg_submission_date: null,
  isDataLoading: false,
  trackList: [],
  vendor_opts: [],
  Parchitecture: "",
  Puse_case: "",
  Poffer: "",
  Puse_case_type: "",
  PincentiveTotal: "",
  selectedId: null,
  refetchAfterRegister: false,

  //Edit Plan register

  EWSdeal_id: "",
  EDeal_id: "",
  EWSact_id_u: "",
  EWSact_id_e: "",
  EWSact_id_a: "",
  ECRparty_id: "",
  register_plan_edit_popup: false,
  Eplan_id: "",
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_QUOTE_DATA:
      return { ...state, ...action.payload };
    case SET_QUOTE_LOADING:
      return { ...state, isQuoteLoading: true };
    case DATA_FETCH_INIT:
      return { ...state, isDataLoading: true, ...action.payload };
    case SET_COMMON_ERROR_VALIDATOR: {
      const { name, value } = action.payload;
      return {
        ...state,
        commonErrorValidator: {
          ...state.commonErrorValidator,
          [name]: value,
        },
      };
    }
    case RESET_COMMON_ERROR_VALIDATOR:
      return {
        ...state,
        commonErrorValidator: {},
      };
    default:
      return state;
  }
};
